module.exports = __webpack_public_path__ + "img/manage05.96df2f68.png";